import React from 'react';
import { render } from 'react-dom';
import App from './components/AppContainer';
import './startup/mixpanel';

render(<App />, document.getElementById('root'));
